import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import RequestListSelect from "./request-list-select";
import RequestListClassificationSelectContainer from "./request-list-classification-select-container";
import DocumentRequestList from "./document-request-list";
import GenericModal from "@Shared/components/modals/generic-modal";
import { mapState, mapActions, mapGetters } from "vuex";
import { LOAD_DOCUMENTS, SAVE_REQUEST_LIST, CREATE_DOCUMENT_CLASSIFICATIONS, DELETE_DOCUMENT_TEMPLATE } from "../../../store/documents-actions";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { cloneDeep, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RequestListModal",
  components: {
    GenericModal,
    RequestListSelect,
    RequestListClassificationSelectContainer,
    DocumentRequestList,
    SimpleButton,
    InlinePrompt
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    preselectedRequestListName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedRequestListName: "",
      creating: false,
      creatingClassifications: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("DocumentsStore", {
    DRAFT_TEMPLATE_NAME(state) {
      return state.DRAFT_TEMPLATE_NAME;
    },
    documentRequestLists(state) {
      return state.documentRequestLists;
    },
    documentRequests(state) {
      return state.documentRequests;
    }
  })), mapGetters("DocumentsStore", ["DOCUMENT_TYPE_DESCRIPTION"])), {}, {
    selectedRequestListEmpty() {
      return !this.selectedRequestListDocumentRequestIds.length;
    },
    selectedRequestList() {
      return this.documentRequestLists.byId[this.selectedRequestListName || this.DRAFT_TEMPLATE_NAME];
    },
    selectedRequestListDocumentRequestIds() {
      var _this$selectedRequest;
      return ((_this$selectedRequest = this.selectedRequestList) == null ? void 0 : _this$selectedRequest.documentRequests) || [];
    },
    currentListIsDraft() {
      var _this$selectedRequest2;
      return (_this$selectedRequest2 = this.selectedRequestList) == null ? void 0 : _this$selectedRequest2.draft;
    }
  }),
  watch: {
    preselectedRequestListName(value) {
      if (value) {
        this.selectedRequestListName = value;
      }
    },
    selectedRequestListDocumentRequestIds(newVal) {
      if (!newVal || isEmpty(newVal)) this.handleSelectRequestList(this.DRAFT_TEMPLATE_NAME);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [LOAD_DOCUMENTS, SAVE_REQUEST_LIST, CREATE_DOCUMENT_CLASSIFICATIONS, DELETE_DOCUMENT_TEMPLATE])), {}, {
    hideModal() {
      this.$refs.modal.hide();
    },
    async handleUseTemplate() {
      var _context;
      this.creatingClassifications = true;
      const documentRequests = _mapInstanceProperty(_context = this.selectedRequestList.documentRequests).call(_context, documentRequestId => {
        const {
          description,
          classification: documentType,
          sampleDocuments
        } = this.documentRequests.byId[documentRequestId];
        return {
          description,
          documentType,
          sampleDocuments
        };
      });
      await this.CREATE_DOCUMENT_CLASSIFICATIONS({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        documentRequests
      });
      await this.LOAD_DOCUMENTS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      this.creatingClassifications = false;
      this.hideModal();
    },
    handleSaveAsNewTemplate() {
      var _context2;
      if (this.selectedRequestListEmpty) return;
      const requestList = _mapInstanceProperty(_context2 = this.selectedRequestList.documentRequests).call(_context2, documentRequestId => this.documentRequests.byId[documentRequestId]);
      this.$emit("save-as", {
        requestList
      });
    },
    handleSelectRequestList({
      requestListName
    }) {
      this.selectedRequestListName = requestListName;
    },
    async handleAddRequestListClassification({
      documentType,
      id
    }) {
      if (this.currentListIsDraft) {
        this.saveDraftRequestList({
          documentType,
          id
        });
        return;
      }
      this.saveRequestList({
        documentType,
        id
      });
    },
    async saveDraftRequestList({
      documentType,
      id
    }) {
      await this.SAVE_REQUEST_LIST({
        applicationId: this.applicationId,
        documentRequestList: {
          name: this.selectedRequestList.name,
          draft: true
        },
        documentRequests: [{
          classification: documentType,
          createdAt: "",
          description: id === "no-results-btn" ? "" : this.DOCUMENT_TYPE_DESCRIPTION(id),
          draft: true,
          id: `${documentType}-draft-${moment().unix()}`,
          name: this.selectedRequestList.name,
          order: this.selectedRequestList.documentRequests.length,
          sampleDocuments: [],
          updatedAt: ""
        }]
      });
    },
    async saveRequestList({
      documentType,
      id
    }) {
      this.creating = true;
      await this.SAVE_REQUEST_LIST({
        documentRequestList: {
          name: this.selectedRequestList.name,
          draft: this.currentListIsDraft
        },
        documentRequests: [{
          classification: documentType,
          description: id === "no-results-btn" ? "" : this.DOCUMENT_TYPE_DESCRIPTION(id),
          order: this.selectedRequestList.documentRequests.length
        }]
      });
      this.creating = false;
    },
    handleDeleteTemplate() {
      this.DELETE_DOCUMENT_TEMPLATE({
        requestList: cloneDeep(this.selectedRequestList)
      });
    },
    handleHidden() {
      this.$emit("hidden");
    }
  })
});